module.exports = __webpack_public_path__ + "static/media/frijcred.2bac3398.gif";